import { createApiClient } from './ApiClientFactory'

const BASE_URL = import.meta.env.VITE_BASE_URL || 'http://localhost:5000/api/v1'
const apiClient = createApiClient(`${BASE_URL}/user-settings`)

export default {
  async getMe() {
    const response = await apiClient.get('/me')
    return response.data
  },

  async updateMe(payload) {
    const response = await apiClient.put('/me', payload)
    return response.data
  },

  // ── Routines ──────────────────────────────────────────────────────────────

  async addRoutine(payload) {
    const response = await apiClient.post('/me/routines', payload)
    return response.data
  },

  async updateRoutine(routineId, payload) {
    const response = await apiClient.patch(`/me/routines/${routineId}`, payload)
    return response.data
  },

  async deleteRoutine(routineId) {
    const response = await apiClient.delete(`/me/routines/${routineId}`)
    return response.data
  },

  // ── Energy Windows ────────────────────────────────────────────────────────

  async addEnergyWindow(payload) {
    const response = await apiClient.post('/me/energy-windows', payload)
    return response.data
  },

  async updateEnergyWindow(windowId, payload) {
    const response = await apiClient.patch(`/me/energy-windows/${windowId}`, payload)
    return response.data
  },

  async deleteEnergyWindow(windowId) {
    const response = await apiClient.delete(`/me/energy-windows/${windowId}`)
    return response.data
  },
}
